import React from 'react';

import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AvatarSize, AvatarTypes } from '../../../../shared/constants';
import { IUser } from '../../../../types/interfaces/user';
import { getUserViewName } from '../../../../utils/common/shared-util';
import AppUserAvatar from '../../../designe/app-entity-avatar/app-user-avatar/AppUserAvatar';
import { useStyles } from './UserSmallItem.styles';

interface UserSmallItemProps {
  user: IUser;
  onUserClick?: (user: IUser) => void;
}

export default function UserSmallItem(props: UserSmallItemProps) {
  const { user, onUserClick } = props;
  const theme = useTheme();
  const { classes } = useStyles(theme);

  function clickOnUserHandler() {
    if (onUserClick) {
      onUserClick(user);
    }
  }

  return (
    <div className={classes.userWrapper} onClick={clickOnUserHandler}>
      <AppUserAvatar
        entity={user}
        size={AvatarSize.s}
        type={AvatarTypes.round}
      />
      <div className={classes.infoWrapper}>
        <Typography variant="text-lg">{getUserViewName(user)}</Typography>
      </div>
    </div>
  );
}
